module.exports = __webpack_public_path__ + "static/media/learnTribeExample.d19d7275.png";